/**
 * DataSource: envio de notificações do TARP (GUPM-177) — STUB.
 * O conteúdo por perfil é do domínio (`buildTarpNotificacao`). O ENVIO real
 * (Teams/SMS + cadeia de escalonamento por horário — regra de domínio #12) é
 * Blocked-by-external (GUPM-23/24). Trocar só esta impl quando a integração chegar.
 */
import type { Notificacao } from '@/domain/tarp/notificacoes';
import type { DataSourceMeta } from './types';

export interface NotificacoesDataSource extends DataSourceMeta {
  /** Envia uma notificação. POC: no-op registrado; real = integração externa. */
  enviar(n: Notificacao): Promise<void>;
}

export const stubNotificacoes: NotificacoesDataSource = {
  mode: 'mock',
  pendingIntegration: {
    owner: 'Comunicação (Teams/SMS)',
    name: 'Cadeia de notificação TARP',
    status: 'pendente',
    description:
      'Envio real de notificações crítica×secundária + escalonamento por horário (RT Galvani + RT JFB). GUPM-23/24.',
  },
  async enviar(n) {
    // POC: não envia. O conteúdo (por perfil) já é montado no domínio.
    if (import.meta.env.DEV) {
      console.info('[notificacao:stub]', n.relev, n.sev, '—', n.titulo);
    }
  },
};
